export class GlobalConstants {
  public static MobileViewPortSize = '992';
}
